/**
 * @generated SignedSource<<7f29826be5d479e59af73e490e993ad2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type presetConfigurationsQueriesCreateMacroCategoryMutation$variables = {
  displayOrder?: number | null;
  name: string;
};
export type presetConfigurationsQueriesCreateMacroCategoryMutation$data = {
  readonly insertMacroCompositionCategory: {
    readonly displayOrder: number;
    readonly id: string;
    readonly macroCategoryID: number;
    readonly name: string | null;
    readonly sellerID: number;
  };
};
export type presetConfigurationsQueriesCreateMacroCategoryMutation = {
  response: presetConfigurationsQueriesCreateMacroCategoryMutation$data;
  variables: presetConfigurationsQueriesCreateMacroCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "displayOrder"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "displayOrder",
        "variableName": "displayOrder"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "CompositionMacroCategory",
    "kind": "LinkedField",
    "name": "insertMacroCompositionCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "macroCategoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sellerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayOrder",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesCreateMacroCategoryMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "presetConfigurationsQueriesCreateMacroCategoryMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "95c9393aca74c9391261f809c03ae71f",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesCreateMacroCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation presetConfigurationsQueriesCreateMacroCategoryMutation(\n  $name: String!\n  $displayOrder: Int\n) {\n  insertMacroCompositionCategory(name: $name, displayOrder: $displayOrder) {\n    id\n    macroCategoryID\n    name\n    sellerID\n    displayOrder\n  }\n}\n"
  }
};
})();

(node as any).hash = "4903f882d30678ad003d9a7d5618be90";

export default node;
